import React, { useCallback, useEffect, useState } from "react";
import "./ProductReviews.scss";
import { Button, Form, Modal, Spin, message } from "antd";
import { useLocation } from "react-router-dom";
import TableComponent from "../../../components/TableComponent/TableComponent";
import ToastHelper from "../../../services/ToastHelper";
import { postApi } from "../../../utils/apiServices";
import {
  ADD_PRODUCT_VARIANT_REVIEW,
  GET_REVIEWS_BY_PRODUCT_VARIANT,
} from "../../../utils/apiPath";
import { IMAGE_BASE_PATH } from "../../../utils/constant";
import FormInput from "../../../components/FormInputs/FormInput";
import FormRating from "../../../components/FormInputs/FormRating";
import FormAntdUploadBase64 from "../../../components/FormInputs/FormAntdUploads";

const ProductReviews = () => {
  const location = useLocation();
  const productData = location.state.product;
  const [form] = Form.useForm();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [pagination, setPagination] = useState({ current: 1, pageSize: 10 });
  const [isLoading, setIsLoading] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [editData, setEditData] = useState(null);

  useEffect(() => {
    if (editData) {
      form.setFieldsValue({
        review: editData?.review,
        rating: editData?.rating,
        userName: editData?.userName,
        reviewMedia: editData?.reviewMedia || [],
      });
    }
  }, [editData]);

  const showModal = () => {
    setIsModalOpen(!isModalOpen);
    if (!editData) {
      setTimeout(() => {
        form.setFieldsValue({ rating: 5 });
      }, 0);
    }
  };

  const handleAdd = async () => {
    try {
      await form.validateFields();
      const values = form.getFieldsValue();
      setIsLoading(true);
      const medias = values?.reviewMedia?.map(
        (med) => med?.base64?.split(",")[1]
      );
      const payload = {
        productId: productData?.id,
        rating: values?.rating,
        review: values?.review,
        userName: values?.userName,
        reviewMedia: medias,
      };
      const res = await postApi(ADD_PRODUCT_VARIANT_REVIEW, payload);
      setIsLoading(false);
      showModal();
      fetchData();
      message.success("Review added successfully");

      setTimeout(() => {
        form.setFieldsValue({ rating: 5 });
      }, 0);
    } catch (error) {
      console.error("Validation Error:", error);
    }
  };

  const columns = [
    {
      title: "Image",
      dataIndex: "reviewMedia",
      render: (_, record) => (
        <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
          {record?.reviewMedia?.length !== 0 ? (
            <img
              style={{ width: "60px", height: "60px", borderRadius: "8px" }}
              src={`${IMAGE_BASE_PATH}${record?.reviewMedia[0]?.media}`}
              alt={record?.reviewMedia[0]?.altText}
            />
          ) : (
            <h3>{productData?.title}</h3>
          )}
        </div>
      ),
    },
    {
      title: "Review",
      dataIndex: "review",
    },
    {
      title: "Rating",
      dataIndex: "rating",
    },
    {
      title: "Actions",
      dataIndex: "actions",
      render: (_, record) => (
        <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
          <Button onClick={() => handleEdit(record)}>🏀 Edit</Button>
        </div>
      ),
    },
  ];

  const fetcReviews = async () => {
    const payload = {
      pageIndex: pagination.current - 1,
      pageSize: pagination.pageSize,
      searchString: "",
      productId: productData?.id,
    };
    try {
      const res = await postApi(GET_REVIEWS_BY_PRODUCT_VARIANT, payload);

      if (res?.data?.length !== 0) {
        return res;
      } else {
        ToastHelper.error("Something went wrong. Please try again.");
      }
    } catch (err) {
      ToastHelper.error(
        "Failed to connect to the server. Please try again later."
      );
    } finally {
      setIsLoading(false);
    }
    return null;
  };

  const fetchData = useCallback(async () => {
    setLoading(true);
    const result = await fetcReviews();
    setData(result?.data);
    setPagination((prev) => ({ ...prev, total: result?.totalRecords }));
    setLoading(false);
  }, [pagination.current, pagination.pageSize]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  const handleTableChange = (newPagination) => {
    setPagination(newPagination);
  };

  const handleEdit = (record) => {
    showModal();
    setEditData(record);
  };

  return (
    <div className="product-reviews">
      <div className="product-reviews_container">
        <div className="products_header">
          <div className="products_header_left">
            Products Reviews - ({productData?.title})
          </div>
          <div className="products_header_right">
            <Button type="primary" onClick={showModal}>
              Add Review
            </Button>
          </div>
        </div>
        <TableComponent
          columns={columns}
          data={data}
          pagination={pagination}
          loading={loading}
          onTableChange={handleTableChange}
        />
      </div>
      <Modal
        title="Add Review"
        open={isModalOpen}
        onOk={handleAdd}
        onCancel={showModal}
        centered={true}
        maskClosable={false}
      >
        <Spin spinning={isLoading}>
          <div className="category-topic_modal">
            <Form form={form} layout="vertical">
              <FormInput
                label="Username"
                name="userName"
                rules={[
                  {
                    required: true,
                    message: "Please enter userName",
                  },
                ]}
                placeholder="Enter userName"
              />
              <FormInput
                label="Review"
                name="review"
                rules={[
                  {
                    required: true,
                    message: "Please enter review",
                  },
                ]}
                placeholder="Enter review"
              />
              <FormRating
                label="Rating"
                name="rating"
                allowHalf={true}
                rules={[
                  {
                    required: true,
                    message: "Please provide a rating",
                  },
                ]}
              />
              <FormAntdUploadBase64
                label="Upload Images"
                name="reviewMedia"
                form={form}
              />
            </Form>
          </div>
        </Spin>
      </Modal>
    </div>
  );
};

export default ProductReviews;
